/* Kkumi subscribe-confirmed landing — the styled page the rewards worker's
   /confirm 302s to.

   This page makes NO claim it can't prove. It used to render "subscription
   confirmed" by default and only swap to a fallback when the worker appended
   ?status=expired|error — so success was the absence of a query param, and
   anyone who opened, refreshed or forwarded the bare URL was told they were
   subscribed. Neither a query parameter nor the mere fact of having navigated
   here is evidence of anything.

   The only evidence is the ticket the worker minted: HMAC-signed, minutes-long
   TTL, and redeemable EXACTLY ONCE (the worker latches it in D1). We POST it
   to /apps/rewards/confirm-result and reveal whatever that answers. Anything
   else — no ticket, a spent one (a refresh, a second tab, a shared link), a
   forged one, an expired one, a network failure — leaves the server-rendered
   neutral state standing.

   The ticket is stripped from the address bar as soon as it has been read, so
   a copied link carries nothing, and the email the response returns is used
   for one thing: prefilling Shopify's hosted sign-in form via the documented
   `login_hint` parameter. */
(function () {
  var TICKET_PARAM = 't';

  function params() {
    try { return new URLSearchParams(window.location.search); } catch (e) { return null; }
  }

  /* Point every sign-in CTA at the login form with the email prefilled. The
     href already carries ?return_to=…, so login_hint is always an extra pair. */
  function prefillLogin(root, email) {
    root.querySelectorAll('[data-kksc-login]').forEach(function (a) {
      var href = a.getAttribute('href') || '';
      if (!href || href.indexOf('login_hint=') !== -1) return;
      a.setAttribute('href', href + (href.indexOf('?') === -1 ? '?' : '&') + 'login_hint=' + encodeURIComponent(email));
    });
  }

  /* Drop the ticket from the address bar without touching the rest of the
     query (campaign tags and the like) or adding a history entry. Done before
     the fetch resolves, so even a slow round-trip can't leave it copyable. */
  function scrubTicket(qs) {
    if (!window.history || !window.history.replaceState) return;
    qs.delete(TICKET_PARAM);
    var q = qs.toString();
    try {
      window.history.replaceState(window.history.state, '', window.location.pathname + (q ? '?' + q : '') + window.location.hash);
    } catch (e) {}
  }

  function show(root, state) {
    root.querySelectorAll('[data-confirm-state]').forEach(function (el) {
      el.hidden = el.getAttribute('data-confirm-state') !== state;
    });
  }

  /* Back to whatever the server rendered — the neutral "we know nothing" state,
     or the "already subscribed" one for a signed-in subscriber. */
  function showDefault(root) {
    var el = root.querySelector('[data-confirm-default]');
    show(root, el ? el.getAttribute('data-confirm-state') : 'none');
  }

  /* One confirmation, three different facts. `club` means this confirmation
     made them a Kkumi Club member; plain `ok` with first_time means the email
     opt-in landed and nothing more; neither means they had already confirmed
     and today changed nothing. */
  function stateFor(data) {
    if (data.state === 'expired' || data.state === 'error') return data.state;
    if (data.state !== 'ok') return null;
    if (data.club) return 'club';
    return data.first_time ? 'ok' : 'repeat';
  }

  function init(root) {
    if (root.dataset.kkBound) return;
    root.dataset.kkBound = '1';

    var qs = params();
    var ticket = (qs && qs.get(TICKET_PARAM)) || '';
    if (!ticket) return; // nothing to prove — the server-rendered state stands

    show(root, 'checking');
    scrubTicket(qs);

    fetch(root.dataset.resultEndpoint || '/apps/rewards/confirm-result', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ t: ticket })
    }).then(function (res) {
      return res.ok ? res.json() : null;
    }).then(function (data) {
      var state = data ? stateFor(data) : null;
      if (!state) { showDefault(root); return; }
      if (data.email) prefillLogin(root, data.email);
      // The welcome gift is only promised when one was actually issued.
      root.querySelectorAll('[data-kksc-gift]').forEach(function (el) { el.hidden = !data.gift; });
      // Which gift: the worker's answer (`offer`), so the card describes the one in their inbox.
      var offer = data.offer === 'sleeves' ? 'sleeves' : 'bogo';
      root.querySelectorAll('[data-kksc-offer]').forEach(function (el) { el.hidden = el.getAttribute('data-kksc-offer') !== offer; });
      show(root, state);
    }).catch(function () {
      showDefault(root);
    });
  }

  // The script is deferred, so the DOM is already parsed: bind straight away
  // rather than waiting for DOMContentLoaded, which keeps the neutral-state
  // flash before a genuine confirmation as short as the browser allows.
  document.querySelectorAll('[data-kkumi-confirmed]').forEach(init);
})();
